import React, { useEffect, useState, useRef } from "react";
import Image from "../../../elements/image";
import gsap from 'gsap';
import { RichText, Link } from "@sitecore-jss/sitecore-jss-react";
import { PrimaryButton } from "../../../elements";
import { mobileIs, loadScrollMagic, getOverallSettingsClasses } from "../../../utils/siteUtils";
const EexploreMoreItem = (props) => {
  const { data, index, dataSource } = props;
  const isMobile = mobileIs();
  let ScrollMagic, controller, scene, scene2, scene3, scene4, tl, tl2, tl3, tl4;
  useEffect(() => {
    if(isMobile){
      tl = gsap.timeline({paused: true});
      tl.to(`#${idsBg}`,{
        height: 0,
        transitionDuration: '0.14s',
        ease: 'linear'
      })
      tl2 = gsap.timeline({paused: true});
      tl2.to(`#${idsBg}`,{
        height: ((window.innerWidth - 40) / 0.75),
        transitionDuration: '0s',
        ease: 'linear'
      })
  
      tl3 = gsap.timeline({paused: true});
      tl3.to(`#${idstitle}`,{
        marginTop: '-45px',
        transitionDuration: '0.14s',
      },'first').to(`#${idsbtn}`,{
        marginBottom: '0px',
        transitionDuration: '0.14s',
      },'first')
  
      tl4 = gsap.timeline({paused: true});
      tl4.to(`#${idstitle}`,{
        marginTop: '0',
        transitionDuration: '0',
      },'first')
      .to(`#${idsbtn}`,{
        marginBottom: '-45px',
        transitionDuration: '0',
      },'first')
  
      ScrollMagic = loadScrollMagic();
      controller = new ScrollMagic.Controller();
      scene = new ScrollMagic.Scene({
        triggerElement: `#${ids}`,
        triggerHook: 'onEnter',
        offset: '10'
      })
      .addTo(controller)
      scene2 = new ScrollMagic.Scene({
        triggerElement: `#${ids}`,
        triggerHook: 'onLeave',
        offset:-window.innerHeight
      })
      .addTo(controller)
      scene3 = new ScrollMagic.Scene({
        triggerElement: `#${idsImage}`,
        triggerHook: 'onEnter',
        offset:  ((window.innerWidth - 40) / 0.75),
      })
      .addTo(controller)
      scene4 = new ScrollMagic.Scene({
        triggerElement: `#${idsImage}`,
        triggerHook: 'onEnter',
        offset:   ((window.innerWidth - 40) / 0.75)/2,
      })
      .addTo(controller)
  
      scene.on("progress", function(event) {
        let ep = event.progress;
        let es = event.scrollDirection;
        if(es == 'FORWARD'){
          tl.restart()
        }
      });
      scene2.on("progress", function(event) {
        let ep = event.progress;
        let es = event.scrollDirection;
        if(es == 'REVERSE'){
          tl2.restart().duration(0)
        }
      });
      scene3.on("progress", function(event) {
        let ep = event.progress;
        let es = event.scrollDirection;
        if(es == 'FORWARD'){
          tl3.restart()
        }
      });
      scene4.on("progress", function(event) {
        let ep = event.progress;
        let es = event.scrollDirection;
        if(es == 'REVERSE'){
          tl4.restart().duration(0)
        }
      });
    }
    return () => {
      scene && scene.destroy(true);
      scene = null;
      scene2 && scene2.destroy(true);
      scene2 = null;
      scene3 && scene3.destroy(true);
      scene3 = null;
      scene4 && scene4.destroy(true);
      scene4 = null;
      controller&&controller.destroy(true);
      controller = null;
    }
	},[])
  const toLink = _ => {
    document.body.style.overflowY = "auto";
  }
	const imageValue = isMobile ? data?.fields?.imageMobile.value : data?.fields?.image.value;
	const firstTitle = isMobile ? data?.fields?.firstTitleMobile : data?.fields?.firstTitle;
	const secondTitle = isMobile ? data?.fields?.secondTitleMobile : data?.fields?.secondTitle;
	const subTitle = isMobile ? data?.fields?.subTitleMobile : data?.fields?.subTitle;
  const btn = data?.fields?.btn;
  const ids = `EexploreMoreItem-${index}`;
  const idsBg = `EexploreMoreItem-${index}-bg`;
  const idstitle = `EexploreMoreItem-${index}-title`;
  const idsImage = `EexploreMoreItem-${index}-image`;
  const idsbtn= `EexploreMoreItem-${index}-btn`;
	return (
		<div className="content" id={ids}>
      <div className="bg" id={idsBg}></div>
			<Image className="img" id={idsImage} { ...imageValue} />
      {!isMobile && 
        <div className="content-text">
          <RichText className="title" id={idstitle} field={firstTitle} />
          <RichText className="titleSecond" field={secondTitle} />
          <RichText className={["subTitle", !secondTitle.value ? 'active' : ''].join(' ')}  field={subTitle} />
          {btn?.fields?.btnText?.value && <div className="btn" id={idsbtn} onClick={v=>toLink()}>
            <PrimaryButton {...btn?.fields} />
          </div>}
        </div>
      }
      {isMobile && 
        <>
        <RichText className="title" id={idstitle} field={firstTitle} />
        <RichText className="titleSecond" field={secondTitle} />
        <RichText className={["subTitle", !secondTitle.value ? 'active' : ''].join(' ')}  field={subTitle} />
        {btn?.fields?.btnText?.value && <div className="btn" id={idsbtn} onClick={v=>toLink()}>
          <PrimaryButton {...btn?.fields} />
        </div>}
        </>
      }
	</div>
	);
};
export default EexploreMoreItem;
